document.addEventListener("DOMContentLoaded", function () {
    const $priceDom = $("#sp_price1");
    const $cPriceDom = $("#sp_price2");
    const $offPriceDom = $(".font-off");
    const $numDom = $("#calcNumber");

    const productData = window.product || [];

    // 跳转支付页面
    $(document).on("click", ".sp-btn-style", function () {
        let num = $("#calcNumber").val();
        window.location.href = "/cart/" + getCur().id + ":" + num;
    });

    /** 获取当前选中的变量 */
    function getCur() {
        const opts = {
            option1: $("#sp-opt-group1 div.active").attr("data-val"),
            option2: $("#sp-opt-group2 div.active").attr("data-val"),
            option3: $("#sp-opt-group3 div.active").attr("data-val"),
        };

        return productData.find((item) => {
            return (
                (!opts.option1 || item.option1 == opts.option1) &&
                (!opts.option2 || item.option2 == opts.option2) &&
                (!opts.option3 || item.option3 == opts.option3)
            );
        });
    }

    /** 更新价格显示 */
    function changePrice() {
        const curVariant = getCur();
        if (!curVariant) return;

        const num = parseInt($numDom.val()) || 1;

        // 识别当前页面使用的小数点符号
        const currentText = $priceDom.text().trim();
        const decimalMatch = currentText.match(/([\.,])(\d+)(?!.*[\.,])/);

        const decimalSeparator = decimalMatch ? decimalMatch[1] : ".";
        const decimalLength = decimalMatch ? decimalMatch[2].length : 0;

        // 格式化输出
        const formatValue = (cents) => {
            let val = ((cents * num) / 100).toFixed(decimalLength);
            if (decimalSeparator === ",") {
                val = val.replace(".", ",");
            }
            return val;
        };

        const price = formatValue(curVariant.price);
        const compare = formatValue(curVariant.compare_at_price);

        // 计算折扣
        let offPercent = 0;
        if (curVariant.compare_at_price > curVariant.price) {
            offPercent =
                100 - Math.ceil((curVariant.price / curVariant.compare_at_price) * 100);
        }

        const priceRegex = /\d+(?:[.,]\d+)*/;
        const offRegex = /(\d+)(?=(?:<[^>]+>|\s)*%)/g;

        const updateHTML = ($el, regex, value) => {
            if ($el && $el.length) {
                const text = $el[0].textContent.trim();
                const newHtml = text.replace(regex, value);
                if ($el.html() !== newHtml) {
                    $el.html(newHtml);
                }
            }
        };

        updateHTML($priceDom, priceRegex, price);
        updateHTML($cPriceDom, priceRegex, compare);
        updateHTML($offPriceDom, offRegex, offPercent);
    }
    // 倒计时
    function getRandomNum(min, max) {
        return Math.floor(Math.random() * (max - min)) + min;
    }

    let endTimeG;

    function cutDownTime() {
        let nowTime = new Date();
        let endTime = new Date(endTimeG);

        let leftTime = endTime.getTime() - nowTime.getTime();
        if (leftTime < 0) {
            setupNewCountdown();
            leftTime = 0;
        }
        let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
            leftM = Math.floor((leftTime / (1000 * 60)) % 60),
            leftS = Math.floor((leftTime / 1000) % 60);
        leftH = leftH >= 10 ? leftH : "0" + leftH;
        leftM = leftM >= 10 ? leftM : "0" + leftM;
        leftS = leftS >= 10 ? leftS : "0" + leftS;

        return {
            hour: leftH,
            minute: leftM,
            second: leftS,
        };
    }
    function setupNewCountdown() {
        const randomHour = getRandomNum(1, 9);
        const currentTime = new Date();
        endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
    }
    let intervalId;

    function getCutDownTime() {
        setupNewCountdown();
        if (intervalId) clearInterval(intervalId);
        intervalId = setInterval(function () {
            let cutDownTimeText = cutDownTime();
            $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
            $(".sp_top_cut_down .sp_left_view .sp_minute").html(
                cutDownTimeText.minute,
            );
            $(".sp_top_cut_down .sp_left_view .sp_second").html(
                cutDownTimeText.second,
            );
        }, 1000);
    }

    getCutDownTime();

    new WOW().init();

    jQuery(".sp-scroll").slide({
        mainCell: ".nav-imgs",
        autoPlay: true,
        effect: "leftMarquee",
        interTime: 12,
        vis: 1,
        scroll: 1,
    });

    new Swiper(".mySwiper", {
        speed: 5000,
        autoplay: true,
        autoplay: {
            delay: 1,
            disableOnInteraction: false,
        },
        slideShadows: true,
        slidesPerView: "auto",
        spaceBetween: 0,
        loop: true,
    });

    new Swiper(".sp-swiper1", {
        autoplay: true,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        slideShadows: true,
        slidesPerView: "auto",
        spaceBetween: 0,
        centeredSlides: true,
        loop: true,
    });

    new Swiper(".sp-swiper2", {
        autoplay: true,
        autoplay: {
            delay: 200000,
            disableOnInteraction: false,
        },
        slideShadows: true,
        slidesPerView: "auto",
        spaceBetween: 0,
        centeredSlides: true,
        loop: true,
        pagination: {
            el: ".sp-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: ".sp-swiper-btn-next",
            prevEl: ".sp-swiper-btn-prev",
        },
    });

    new Swiper(".sp-swiper-fade", {
        spaceBetween: 10,
        effect: "fade",
        autoplay: true,
        autoplay: {
            disableOnInteraction: false,
            delay: 2000,
        },
        speed: 2000,
    });

    new Swiper(".sp-swiper-fade1", {
        autoplay: true,
        autoplay: {
            disableOnInteraction: false,
        },
        spaceBetween: 10,
        loop: true,
        on: {
            slideChange: function (e) {
                e.slides.find(".sp-item").each(function () {
                    this.style.animation = "none";
                });
                const spText = e.slides.eq(e.activeIndex).find(".sp-item")[0];
                if (spText) {
                    spText.style.animation = "none";

                    spText.style.animation = `swiper-up-fade 0.5s ease forwards`;
                }
            },
        },
    });

    new Swiper(".sp-swiper0", {
        autoplay: true,
        autoplay: {
            disableOnInteraction: false,
        },
        spaceBetween: 10,
        loop: true,
    });

    function mainRender() {
        $(function () {
            $("#root").css("zoom", "normal");
            if (document.body.clientWidth <= 1060) {
                let scale = document.body.clientWidth / 1080;
                $("#root").css("zoom", scale);
            } else {
                const scale = document.body.clientWidth / 1920;
                $("#root").css("zoom", scale);
            }

            window.addEventListener(
                "resize",
                (function () {
                    var timer;
                    return function () {
                        if (timer) clearTimeout(timer);
                        timer = setTimeout(function () {
                            $("#root").css("zoom", "normal");
                            if (document.body.clientWidth <= 1060) {
                                let scale = document.body.clientWidth / 1080;
                                $("#root").css("zoom", scale);
                            } else {
                                const scale = document.body.clientWidth / 1920;
                                $("#root").css("zoom", scale);
                            }
                        }, 100);
                    };
                })(),
            );
        });

        function lazyLoadImages() {
            // 懒加载
            const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
            const config = {
                rootMargin: "0px 0px 1300px 0px",
                threshold: 0,
            };

            const lazyLoadObserver = new IntersectionObserver(function (
                entries,
                observer,
            ) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        // 当图片进入视口时
                        const image = entry.target;
                        const dataSrc = image.getAttribute("data-src");
                        if (dataSrc) {
                            image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
                        }
                        lazyLoadObserver.unobserve(image); // 停止观察该图片
                    }
                });
            }, config);

            images.forEach(function (image) {
                lazyLoadObserver.observe(image); // 开始观察每个图片
            });
        }

        function preloadImages(imageArray) {
            // 预加载
            // 检查数组数据结构
            if (Array.isArray(imageArray[0])) {
                // 处理二维数组
                imageArray.forEach((subArray) => {
                    subArray.forEach((url) => {
                        const img = new Image();
                        img.src = url;
                    });
                });
            } else {
                // 处理一维数组
                imageArray.forEach((url) => {
                    const img = new Image();
                    img.src = url;
                });
            }
        }

        lazyLoadImages();

        let imgList = [
            "https://cdn.shopify.com/s/files/1/0727/8844/3441/files/20260508-p1.png",
            "https://cdn.shopify.com/s/files/1/0727/8844/3441/files/20260508-p2.png",
            "https://cdn.shopify.com/s/files/1/0727/8844/3441/files/20260508-p3.png",
            "https://cdn.shopify.com/s/files/1/0727/8844/3441/files/20260508-p4.png",
            "https://cdn.shopify.com/s/files/1/0727/8844/3441/files/20260508-p5.png",
        ];
        $(".product-part .sp-img-wrap .sp-pkg-panel img").each(function () {
            var s = $(this).attr("src");
            if (s && imgList.indexOf(s) === -1) {
                imgList.push(s);
            }
        });
        // if (!imgList.length) {
        //   for (let i = 1; i <= 5; i++) {
        //     imgList.push("https://cdn.shopify.com/s/files/1/0727/8844/3441/files/20260508-p" + i + ".png");
        //   }
        // }
        if (imgList.length) {
            preloadImages(imgList);
        }

        var pkgPanelFirstRun = true;

        function getPkgTypeIndex() {
            var typeIndex = $("#sp-opt-group2 .sp-option.active").index();
            return typeIndex < 0 ? 0 : typeIndex;
        }
        function getGroup3TypeIndex() {
            var typeIndex = $("#sp-opt-group3 .sp-option.active").index();
            return typeIndex < 0 ? 0 : typeIndex;
        }

        function getMainOptionIndex() {
            var optionIndex = $("#sp-opt-group1 .sp-option.active").index();
            return optionIndex < 0 ? 0 : optionIndex;
        }

        function getCurrentVariantImageSrc() {
            var curVariant = getCur();
            if (!curVariant || !curVariant.featured_image) return "";

            if (typeof curVariant.featured_image === "string") {
                return curVariant.featured_image;
            }

            return curVariant.featured_image.src || curVariant.featured_image.url || "";
        }

        function syncMainPkgPanelImage($panel) {
            var $img = $panel.find("img").first();
            if (!$img.length) return;

            if (!$img.attr("data-original-src")) {
                $img.attr("data-original-src", $img.attr("src") || "");
            }

            if (getMainOptionIndex() === 1) {
                var variantImageSrc = getCurrentVariantImageSrc();
                if (variantImageSrc) {
                    $img.attr("src", variantImageSrc);
                }
                $panel.addClass("sp-full-variant-panel");
                $panel.find(".sp-text").hide();
                return;
            }

            var originalSrc = $img.attr("data-original-src");
            if (originalSrc) {
                $img.attr("src", originalSrc);
            }
            $panel.removeClass("sp-full-variant-panel");
            $panel.find(".sp-text").show();
        }

        function updateMainPkgPanel(playAnim) {
            var idx = getPkgTypeIndex() + getMainOptionIndex() * 3 + getGroup3TypeIndex() * 6;
            var $panels = $(".product-part .sp-img-wrap .sp-pkg-panel");
            $panels.removeClass("active");
            var $show = $panels.filter('[data-pkg-index="' + idx + '"]');
            if ($show.length) {
                $show.addClass("active");
            } else {
                $show = $panels.first().addClass("active");
            }
            // syncMainPkgPanelImage($show);
            if (playAnim && !pkgPanelFirstRun) {
                var el = $show[0];
                if (el) {
                    el.style.animation = "none";
                    void el.offsetWidth;
                    // el.style.animation = "swiper-up-fade 0.5s ease forwards";
                }
            }
            pkgPanelFirstRun = false;
        }

        $(".sp-option").click(function () {
            $(this).siblings().removeClass("active");
            $(this).addClass("active");
            updateMainPkgPanel(true);
            changePrice();
        });

        updateMainPkgPanel(false);

        var brandLayoutTimer;
        function scheduleUpdateMainPkgPanelForResize() {
            if (brandLayoutTimer) clearTimeout(brandLayoutTimer);
            brandLayoutTimer = setTimeout(function () {
                updateMainPkgPanel(false);
            }, 100);
        }
        window.addEventListener("resize", scheduleUpdateMainPkgPanelForResize);
        window.addEventListener(
            "orientationchange",
            scheduleUpdateMainPkgPanelForResize,
        );

        // IOS字体多了间距的处理
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;
        var isAndroid = /android/i.test(userAgent);
        var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
        var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent);

        if (!isAndroid && !isIOS && !isPC) {
            $(".sp_system").css("letter-spacing", "-4px");
        }
    }

    mainRender();

    // 找到所有跳转套餐的锚点链接 - 使用事件委托确保所有链接都能工作
    // function handleShoppingLinkClick(event) {
    //     // const link = event.target.closest('a[href="#shopping"]');
    //     // if (!link) return;

    //     // event.preventDefault();

    //     // const targetElement = document.getElementById("shopping");
    //     // if (targetElement) {
    //     //   const offsetTop = targetElement.offsetTop;
    //     //   let sptop = document.body.clientWidth <= 1080 ? 360 : 380;
    //     //   let zoomValue = parseFloat($("div#root").css("zoom")) || 1;
    //     //   const scrollTop = offsetTop * zoomValue - sptop * zoomValue;

    //     //   window.scrollTo({
    //     //     top: scrollTop,
    //     //     behavior: "smooth",
    //     //   });

    //     //   setTimeout(() => {
    //     //     if (
    //     //       window.pageYOffset === 0 ||
    //     //       Math.abs(window.pageYOffset - scrollTop) > 100
    //     //     ) {
    //     //       $("html, body").animate(
    //     //         {
    //     //           scrollTop: scrollTop,
    //     //         },
    //     //         800,
    //     //       );
    //     //     }
    //     //   }, 100);
    //     // }
    //     var links = document.querySelectorAll('a[href^="#shopping"]');
    //     links.forEach(function (link) {
    //         link.addEventListener("click", function (event) {
    //             event.preventDefault();

    //             const target = document.getElementById("shopping");
    //             if (!target) return;

    //             const timeHeight =
    //                 document.querySelector(".time-part")?.getBoundingClientRect().height || 0;

    //             const headerHeight =
    //                 document.querySelector(".sp-header-top")?.getBoundingClientRect().height || 0;

    //             const targetTop =
    //                 target.getBoundingClientRect().top + window.scrollY;

    //             window.scrollTo({
    //                 top: targetTop - timeHeight - headerHeight,
    //                 behavior: "smooth",
    //             });
    //         });
    //     });
    // }

    // // 使用事件委托在document上监听所有点击
    // document.addEventListener("click", handleShoppingLinkClick);

    let sp_price1 = 14.5;
    let sp_price2 = 27.0;

    function calcTotal(price, num) {
        let result = Number(price) * Number(num);
        return result.toFixed(3);
    }
    $(".sp-reduce").click(function () {
        let input = $(this).siblings("input")[0];
        let num = Number(input.value) - 1;
        if (num > 0) {
            input.value = num;
        }
        changePrice();
        // $("#sp_price1").html(calcTotal(sp_price1, input.value) + ' Ft');
        // $("#sp_price2").html(calcTotal(sp_price2, input.value) + ' Ft');
    });
    $(".sp-add").click(function () {
        let input = $(this).siblings("input")[0];
        let num = Number(input.value) + 1;
        input.value = num;
        changePrice();
        // $("#sp_price1").html(calcTotal(sp_price1, input.value) + ' Ft');
        // $("#sp_price2").html(calcTotal(sp_price2, input.value) + ' Ft');
    });

    // 标题文本渐出
    const graduallyList = document.getElementsByClassName("gradually");
    for (let gradually of graduallyList) {
        const spans = gradually.querySelectorAll("span, div");
        const paragraph = gradually.querySelector(".sp-sub-title");

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        // 给每个 span/div 和 i 动画
                        spans.forEach((span, index) => {
                            span.style.animation = `swift-up-fade 0.5s ease forwards`;
                            span.style.animationDelay = `${index * 0.1}s`;

                            const i = span.querySelector("i");
                            if (i) {
                                i.style.animation = `swift-up-fade 0.5s ease forwards`;
                                i.style.animationDelay = `${index * 0.1}s`;
                            }
                        });

                        // 段落
                        const totalDelay = spans.length * 0.1 + 0.3;
                        if (paragraph) {
                            paragraph.style.animation = `swift-up-fade2 0.5s ease forwards`;
                            paragraph.style.animationDelay = `${totalDelay}s`;
                        }

                        observer.unobserve(gradually);
                    }
                });
            },
            {
                threshold: 0.3,
            },
        );
        observer.observe(gradually);
    }

    // 菜单
    $(".sp-menu-btn").click(function (e) {
        $(".sp-menu-mask").show();
    });

    $(".sp-menu-mask").click(function (e) {
        $(".sp-menu-mask").hide();
    });

    $(function () {
        // 判断是否为移动端
        function isMobile() {
            return document.body.clientWidth <= 1060;
        }

        // 购物车加购动效
        $(".cart-btn").click(function () {
            $(this).children("img").addClass("on");
            if (isMobile()) {
                $(".sp-mobile .sp-cart .num").show();
                $(".sp-mobile .sp-cart").addClass("on");
                setTimeout(function () {
                    $(".sp-mobile .sp-cart").removeClass("on");
                }, 500);
            } else {
                $(".sp-pc .sp-header-top .sp-cart .num").show();
                $(".sp-pc .sp-header-top .sp-cart").addClass("on");
                setTimeout(function () {
                    $(".sp-pc .sp-header-top .sp-cart").removeClass("on");
                }, 500);
            }
            setTimeout(function () {
                $(".cart-btn").children("img").removeClass("on");
            }, 500);
        });

        let initNum = 0;

        $(".product-part .cart-btn").click(function () {
            let spNum = $("#calcNumber")[0].value;
            //   initNum += Number(spNum);
            var data = {
                id: getCur().id,
                quantity: spNum,
            };
            $.ajax({
                type: "POST",
                url: "/cart/add.js",
                data: data,
                success: function () {
                    $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
                        // $("#cardNum").html(result.item_count);
                        // console.log("result",result.item_count)
                        initNum = result.item_count;
                        // 更新购物车数量
                        if (isMobile()) {
                            $(".sp-mobile .cardNum").each(function () {
                                $(this).html(initNum);
                            });
                        } else {
                            $(".sp-pc .cardNum").each(function () {
                                $(this).html(initNum);
                            });
                        }
                        $(".cardNum").removeClass("sp-gray");
                    });
                },
                dataType: "json",
            });

            var $panel = $(".product-part .sp-img-wrap .sp-pkg-panel.active");
            if (!$panel.length) {
                return;
            }
            var el = $panel[0];
            var rect = el.getBoundingClientRect();
            if (rect.width < 2 || rect.height < 2) {
                return;
            }

            var flyer = el.cloneNode(true);
            flyer.classList.remove("active");
            flyer.classList.add("sp_pkg_flyer", "sp_clone");

            $(".product-part").append(flyer);
            $(flyer).css({
                position: "fixed",
                top: rect.top,
                left: rect.left,
                width: rect.width,
                height: rect.height,
                margin: 0,
                boxSizing: "border-box",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexWrap: "wrap",
                background: "#e7e9ef",
                zIndex: 99,
                pointerEvents: "none",
                overflow: "hidden",
            });

            let finish, targetTop, targetLeft;

            if (isMobile()) {
                finish = $(".sp-btn-style2.sp-mobile .sp-cart");
                if (finish.length > 0) {
                    targetTop = $(".sp-btn-style2")[0].offsetTop;
                    targetLeft = $(".sp-btn-style2 .sp-cart")[0].offsetLeft;
                } else {
                    targetTop = 0;
                    targetLeft = 0;
                }
            } else {
                finish = $(".sp-pc .sp-cart");
                if (finish.length > 0) {
                    targetTop = finish[0].offsetTop;
                    targetLeft = finish[0].offsetLeft;
                } else {
                    targetTop = 0;
                    targetLeft = 0;
                }
            }

            $(flyer).animate(
                {
                    top: targetTop,
                    left: targetLeft,
                    width: 50,
                    height: 50,
                    opacity: 0.4,
                },
                500,
                "linear",
                function () {
                    $(this).animate(
                        {
                            width: 0,
                            height: 0,
                            opacity: 0,
                        },
                        0,
                        function () {
                            $(this).detach();
                        },
                    );
                },
            );
        });
    });

    // 问答 - 手风琴模式：展开当前项时收起其他项
    $(".q-row").on("click", function () {
        var $currentItem = $(this).parent();
        var $answer = $currentItem.find(".sp-text");

        // 当前项已展开：点击后收起
        if ($currentItem.hasClass("sp-show")) {
            $answer.slideUp(300, function () {
                $currentItem.removeClass("sp-show");
            });
        } else {
            // 打开当前项前，先关闭其他已展开项
            $(".sp-part11 .sp-box > div").removeClass("sp-show");
            $(".sp-part11 .sp-text").slideUp(300);

            $currentItem.addClass("sp-show");
            $answer.slideDown(300);
        }
    });

    // 文本渐出动画
    const graduallyList2 = document.getElementsByClassName("sp-fade-box");
    for (let gradually2 of graduallyList2) {
        const paragraph2 = gradually2.querySelectorAll(".sp-ani");

        const observerAni = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        paragraph2.forEach((span, index) => {
                            span.style.animation = `sp-fade-in 1s ease forwards`;
                            span.style.animationDelay = `${index * 0.5 + 0.5}s`;
                        });

                        observerAni.unobserve(gradually2);
                    }
                });
            },
            {
                threshold: 0.3,
            },
        );
        observerAni.observe(gradually2);
    }
    // 文本渐出动画
    const graduallyList3 = document.getElementsByClassName("sp-fade-box2");
    for (let gradually3 of graduallyList3) {
        const paragraph3 = gradually3.querySelectorAll(".sp-ani2");

        const observerAni = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        paragraph3.forEach((span, index) => {
                            span.style.animation = `sp-fade-left 1s ease forwards`;
                            span.style.animationDelay = `${index * 0.3 + 1}s`;
                        });

                        observerAni.unobserve(gradually3);
                    }
                });
            },
            {
                threshold: 0.3,
            },
        );
        observerAni.observe(gradually3);
    }
});
